// node_modules
import React from "react";

// redux
import { useSelector, useDispatch } from "react-redux";

// assets
import spinner from "../../assets/loader.svg";

// styles
import * as styles from "./Loader.module.css";

const Loader = () => {
  const showLoader = useSelector((state) => state.app.loading);

  return (
    <>
      {showLoader && (
        <div className={styles.loaderContainer}>
          <img src={spinner} alt="Loading..." className="w-16 h-16" />
        </div>
      )}
    </>
  );
};

export default Loader;
